const API_URL = process.env.VUE_APP_API_URL
const getToken = () => localStorage.getItem('access-token')

async function request (path, { method = 'GET', body, json = true } = {}) {
  const headers = { 'Authorization': getToken() }
  if (json && body !== undefined) headers['Content-Type'] = 'application/json'
  const response = await fetch(`${API_URL}${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : (json ? JSON.stringify(body) : body)
  })
  const resp = await response.json()
  if (!response.ok || resp.success === false) {
    throw new Error(resp.error || 'Error inesperado')
  }
  return resp
}

async function download (path) {
  const response = await fetch(`${API_URL}${path}`, {
    method: 'GET',
    headers: { 'Authorization': getToken() }
  })
  if (!response.ok) {
    const resp = await response.json().catch(() => ({}))
    throw new Error(resp.error || 'No se pudo descargar el archivo')
  }
  const disposition = response.headers.get('Content-Disposition') || ''
  const match = disposition.match(/filename="?([^"]+)"?/)
  return {
    blob: await response.blob(),
    fileName: match ? decodeURIComponent(match[1]) : 'archivo.xlsx'
  }
}

export default {
  getPartnersAPI () {
    return request('/v5/admin/partners')
  },
  updatePartnerAPI (partnerId, data) {
    return request(`/v5/admin/partners/${partnerId}`, { method: 'PUT', body: data })
  },
  getPartnerPricesAPI (partnerId, filters = {}) {
    const params = new URLSearchParams()
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') params.append(key, value)
    })
    return request(`/v5/admin/partners/${partnerId}/prices?${params.toString()}`)
  },
  importPartnerPricesAPI (partnerId, file, { validFrom, validTo } = {}) {
    const formData = new FormData()
    formData.append('file', file)
    if (validFrom) formData.append('validFrom', validFrom)
    if (validTo) formData.append('validTo', validTo)
    return request(`/v5/admin/partners/${partnerId}/prices/import`, { method: 'POST', body: formData, json: false })
  },
  getPartnerPriceImportsAPI (partnerId) {
    return request(`/v5/admin/partners/${partnerId}/price-imports`)
  },
  getPartnerPriceImportAPI (importId) {
    return request(`/v5/admin/partner-price-imports/${importId}`)
  },
  downloadPartnerPriceReportAPI (importId) {
    return download(`/v5/admin/partner-price-imports/${importId}/report`)
  },
  publishPartnerPriceImportAPI (importId) {
    return request(`/v5/admin/partner-price-imports/${importId}/publish`, { method: 'POST' })
  },
  discardPartnerPriceImportAPI (importId) {
    return request(`/v5/admin/partner-price-imports/${importId}/discard`, { method: 'POST' })
  }
}
